import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { alert_error, alert_success } from "../AppContext.js";
import { Cookies } from './../index.js';
import AdModal from './../app_structure/AdModal';
import AdSense from 'react-adsense';
function MyComponent() {
    const [jsonArr, setJsonArr] = useState([]);
    const [id, setId] = useState(null);
    const [dasaochep, setDasaochep] = useState(null);
    const [error, setError] = useState(null);
    const [nutxuly, setnutxuly] = useState(0);
    const [nangcap, set_nangcap] = useState('');

    useEffect(() => {
        get_info();
    }, []);
    useEffect(() => {
        if (nangcap) {
            danhchimuc();
        }
    }, [nangcap]);
    const get_info = () => {
        axios
            .get('https://nginx.hust.media/go/profile/plan/list_plan', {
                chedo: 'getinfo',
            })
            .then(response => set_nangcap(response.data))
            .catch(error => console.log(123 + error));
    };
    const danhchimuc = () => {
        let tongxunhan = 0;
        const jsonArr = [];
        nangcap.forEach((item) => {
            tongxunhan += Number(item.thucnhan);
            jsonArr.push({
                ...item,
                tongxunhan: tongxunhan
            });
        });
        setJsonArr(jsonArr);
    };

    const saochepp = (id) => {
        console.log(id);
        setnutxuly(1);
        setId(id);
        setDasaochep('Please wait a moment 😊');
        const apiKey = Cookies.get('apikey');
        axios.post('https://nginx.hust.media/go/profile/plan/plan_orders', {
            key: apiKey,
            mucnhan: id
        })
            .then(response => {
                setnutxuly(0);
                console.log(response.data);
                dathang(response.data);
            })
            .catch(error => alert_error(error));
    };

    const dathang = (response) => {
        setDasaochep(response.error ? response.error : response.order);
        if (response.error) {
            alert_error(response.error);
        }
        else if (response.order) {
            alert_success(response.order);
        }
    };
    const [showAd, setShowAd] = useState(true);
    const handleCloseAd = () => {
        setShowAd(false);
    };
    return (
        <div>
            <div className="">
                <div className="text-center">
                    <AdModal isOpen={showAd} onClose={handleCloseAd} />
                    <Link to="/shop/profiles/home?webappmode=showadview">
                        <button type="button" className="mx-2 btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            Xem Tổng Coins kiếm được
                        </button>
                    </Link>
                </div>
                <div className="max-h-16">
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="1627514116"
                            style={{ display: 'block' }}
                            format='horizontal'
                            responsive='false'
                        /></div>
                </div>
                <div className='mx-2'>
                    <table className="table-auto relative w-full border border-separate text-break text-sm">
                        <thead className="bg-blue-500 text-white">
                            <tr>
                                <th className="p-1">Cấp độ</th>
                                <th className="p-1">Mức Coins</th>
                                <th className="p-1">Thưởng khi<br />nâng cấp</th>
                                <th className="p-1">Tổng thưởng</th>
                                <th className="p-1 text-left">Chiết khấu giảm</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jsonArr.map((item) => (
                                <tr key={item.stt} className="bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 lg:text-black">
                                    <td className="p-1 font-medium capitalize">{item.level}</td>
                                    <td className="p-1">{item.soxunap} Coins</td>
                                    <td className="p-1">{item.thucnhan} Coins</td>
                                    <td className="p-1">{item.tongxunhan} Coins</td>
                                    
                                    <td className="p-1">
                                        <div id={item.stt}>{item.chietkhau} % <span onClick={() => saochepp(item.stt)}>
                                            <div className="float-right">
                                                <button disabled={nutxuly == 1} className='text-xs font-medium rounded-full px-2 py-2 space-x-1 bg-white text-black'>
                                                    {id === item.stt ?
                                                        <>
                                                            <div className='flex items-center justify-between flex-1'>
                                                                {nutxuly == 1 && (<>
                                                                    <div className="mr-2 border-gray-300 h-6 w-6 rounded-full border-4 border-t-blue-600 spin-custom" />
                                                                </>
                                                                )}
                                                                {dasaochep}
                                                            </div>
                                                        </> : <>
                                                            Nhận thưởng ngay
                                                        </>}
                                                </button>
                                            </div>
                                        </span></div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default MyComponent;
